<script>

  import { onMount } from 'svelte';
  import { setGroupSettings } from '../service/LmsUIService';
  import { External, M } from '../../external';
  import ImagePicker from '../../Common/ImagePicker.svelte';
  import AccessLevelPicker from '../utils/AccessLevelPicker.svelte';
  import AvailabilityPicker from '../utils/AvailabilityPicker.svelte';
  import { pickIcon } from '../../Common/MaterialIconPicker.svelte';

  export let
    circleDetails,
    group,
    isTemplate = false,
    onChange = () => {
    };

  let pageGroup = group.pageGroup;
  let settings = setGroupSettings(pageGroup);
  let groupUrl = '';


  let layoutOptions = [
    { id: 'text', text: M.TEXT_ONLY },
    { id: 'number', text: M.NUMBER },
    { id: 'icon', text: M.ICON },
    { id: 'icon-large', text: M.ICON_LARGE },
    { id: 'image', text: M.IMAGE },
    { id: 'image-video', text: M.IMAGE_VIDEO }
  ];

  let notifyChanged = () => {
    onChange();
  };

  let pickGroupIcon = async () => {
    let icon = await pickIcon();
    if (icon) {
      settings.layoutIcon = icon;
      notifyChanged();
    }
  };

  let onSetPageUrl = () => {
    groupUrl = External.Tools.urlFromString(groupUrl, false, false, '-', true);
    let urlItems = [
      ...circleDetails.pages,
      ...circleDetails.groups.map(group => group.pageGroup)
    ];

    if (urlItems.filter(item => item.id !== pageGroup.id && item.url === groupUrl).length > 0) {
      groupUrl = pageGroup.url;
      External.Tools.showError(M.PAGE_SAME_URL);
      return;
    }
    pageGroup.url = groupUrl;
    notifyChanged();
  };

  onMount(() => {
    groupUrl = pageGroup.url;
  });

</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> settings </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.GROUP_SETTINGS}</h4>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_NAME}</h5>
    <input type="text" name="circlePageName" placeholder={M.ENTER_DISPLAY_NAME}
           bind:value={pageGroup.name}
           on:change={notifyChanged}>
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.GROUP_URL}</h5>
    <input type="text" name="circleUrl" placeholder={M.ENTER_GROUP_URL}
           bind:value={groupUrl}
           on:change={onSetPageUrl}>
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input id="lmsInnerCirclePageDescription" class="css-checkbox" type="checkbox" name="circlePageDescription"
             bind:checked={settings.showDescription}
             on:change={notifyChanged} />
      <label for="lmsInnerCirclePageDescription" class="css-label">{M.SHOW_GROUP_DESCRIPTION}
        <span>{M.SHOW_GROUP_DESCRIPTION_DESC}</span></label>
    </div>
  </div>
  {#if settings.showDescription}
    <div class="popup-input-wrapper mt-5">
      <h5>{M.DESCRIPTION}</h5>
      <input bind:value={pageGroup.description}
             on:change={notifyChanged}
             type="text" name="innerCircleDescription"
             placeholder={M.ENTER_DISPLAY_DESCRIPTION}>
    </div>
  {/if}

  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input id="lmsInnerCircleTrackingProgress" class="css-checkbox" type="checkbox" name="circlePageDescription"
             bind:checked={settings.showTrackingProgress}
             on:change={notifyChanged} />
      <label for="lmsInnerCircleTrackingProgress" class="css-label">{M.SHOW_TRACKING_PROGRESS}
        <span>{M.SHOW_TRACKING_PROGRESS_DESC}</span></label>
    </div>
  </div>

  <!-- Hide Group -->
  <div class="checkbox-wrapper">
    <input id="hideInnerCircle" class="css-checkbox" type="checkbox" name="hideInnerCircle" bind:checked={pageGroup.hidden}
           on:change={notifyChanged}>
    <label for="hideInnerCircle" class="css-label">
      {M.HIDDEN_GROUP}
      <span>{M.HIDDEN_GROUP_DESC}</span>
    </label>
  </div>
  <!-- Hide Group END -->

  <div class="popup-input-wrapper f-left mt-15">
    <AccessLevelPicker {isTemplate} item="{group.pageGroup}" type="GROUP" onChange="{notifyChanged}" />
  </div>

  <div class="popup-input-wrapper f-left">
    <AvailabilityPicker item="{group.pageGroup}" circleDetails="{circleDetails}" onChange="{notifyChanged}" />
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input id="lmsInnerCircleEnrollRequired" class="css-checkbox" type="checkbox" name="lmsInnerCircleEnrollRequired"
             bind:checked={pageGroup.enroll}
             on:change={notifyChanged} />
      <label for="lmsInnerCircleEnrollRequired" class="css-label">{M.ENROLLMENT_REQUIRED} <span>{M.ENROLLMENT_REQUIRED_DESC}</span></label>
    </div>
  </div>
  <div class="popup-input-wrapper f-left mt-15">
    <div class="info">
      <h5>{M.LAYOUT_NAVIGATION_BAR}</h5>
    </div>
    <select class="page-select" name="circleNavLayout"
            bind:value={settings.layout}
            on:change={notifyChanged}>
      {#each layoutOptions as layout}
        <option value={layout.id}>
          {layout.text}
        </option>
      {/each}
    </select>
  </div>

  {#if settings.layout === 'icon' || settings.layout === 'icon-large'}
    <div class="info">
      <h5>{M.OPTION_ICON}</h5>
      <span>{M.OPTION_ICON_DESC}</span>
    </div>
    <div class="iconpicker-value mt-5" on:click={pickGroupIcon}>
      {#if settings.layoutIcon && settings.layoutIcon.length > 20}
        <span>{@html settings.layoutIcon}</span>
      {:else}
        <span class="material-icons-outlined">{settings.layoutIcon}</span>
      {/if}
    </div>
  {/if}

  {#if settings.layout === 'image' || settings.layout === 'image-video'}
    <ImagePicker onChange={notifyChanged} bind:image={settings.layoutImage} bind:imageBase={settings.layoutImageBase} />
  {/if}

  <div class="col20 f-left mt-15">
    <div class="checkbox-wrapper">
      <input id="lmsInnerCirclePageBadge" class="css-checkbox" type="checkbox" name="circlePageBadge"
             bind:checked={settings.showBadge}
             on:change={notifyChanged} />
      <label for="lmsInnerCirclePageBadge" class="css-label">{M.ADD_A_BADGE} <span>{M.ADD_A_BADGE_DESC}</span></label>
    </div>
  </div>

  {#if settings.showBadge}
    <div class="popup-input-wrapper mt-5">
      <h5>{M.BADGE_LABEL}</h5>
      <input type="text" name="badgeLabel" placeholder={M.ENTER_BADGE_LABEL}
             bind:value={settings.badgeLabel}
             on:change={notifyChanged}>
    </div>
  {/if}
</div>
